import {
  ARROW_DEFAULT_H,
  ARROW_DEFAULT_W,
  ARROW_LEGACY_MIN_W_PX,
  ARROW_MIN_SIZE_PX,
  SECTION_MIN_H,
  SECTION_MIN_W,
  type CanvasObject,
  type ShapeCanvasObject,
} from "@refinement-canvas/domain";

/** 矢印以外の図形をシングルクリックで配置するときの既定サイズ（ステージ px）。 */
const SHAPE_DEFAULT_W = 160;
const SHAPE_DEFAULT_H = 120;

/** 図形をシングルクリック配置するときの既定サイズを返す。 */
export function resolveShapeDefaultFrameSize(shapeKind: ShapeCanvasObject["shapeKind"]): {
  readonly w: number;
  readonly h: number;
} {
  return shapeKind === "arrow"
    ? { w: ARROW_DEFAULT_W, h: ARROW_DEFAULT_H }
    : { w: SHAPE_DEFAULT_W, h: SHAPE_DEFAULT_H };
}

export interface ResizeMinSize {
  readonly minW?: number | undefined;
  readonly minH?: number | undefined;
}

/** オブジェクト種別と矢印の描画経路に合うリサイズ下限を返す。 */
export function resolveResizeMinSize(object: CanvasObject): ResizeMinSize {
  if (object.type === "section") {
    // また、タイトルバーが潰れないよう種別固有の最小サイズ（200×120）でリサイズ下限を課す。
    return { minW: SECTION_MIN_W, minH: SECTION_MIN_H };
  }
  if (object.type !== "shape" || object.shapeKind !== "arrow") {
    return {};
  }
  if (object.arrowFromEdge !== undefined) {
    return { minW: ARROW_MIN_SIZE_PX, minH: ARROW_MIN_SIZE_PX };
  }
  return {
    minW: object.arrowFromCorner === undefined ? ARROW_LEGACY_MIN_W_PX : ARROW_MIN_SIZE_PX,
    minH: ARROW_MIN_SIZE_PX,
  };
}
